module.exports = __webpack_public_path__ + "img/word-m.45054e14.png";